module.exports = __webpack_public_path__ + "img/xiaozhao-logo.d52dac9a.jpg";